import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "w-full flex sx:flex-col justify-start items-start text-slate-900" }
const _hoisted_3 = { class: "mt-6 w-10/12 sx:w-full flex flex-col justify-center items-center m-auto pb-5" }
const _hoisted_4 = { class: "flex flex-col w-11/12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium" }, " Search Book by title, author and other keywords ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "rounded-sm ml-4 px-4 py-2 font-medium bg-boxColor text-white text-sm outline-none hover:shadow-typeBox",
  type: "submit"
}, " Search ", -1)
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "bg-white cursor-pointer text-black text-sm font-normal border-b px-2 py-2" }
const _hoisted_9 = { class: "flex flex-col gap-6 mt-5 justify-center items-center md:w-2/5 w-full" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"p-4 rounded-md gap-6 text-left bg-white border border-gray-400 w-5/6 sx:w-11/12 min-h-fit shadow-bx\"><div class=\"border-b-2 pb-1 border-boxColor flex items-center gap-8 text-sm\"> See Book Stats </div><div class=\"flex items-start justify-center\"><div class=\"w-full text-sm grid grid-rows-3 gap-2 mt-2\"><div class=\"text-sm\">Books Completed:</div><div class=\"text-sm\">Total Pages Read:</div><div class=\"text-sm\">Total Time Spent:</div></div><div class=\"w-full text-sm grid grid-rows-5 gap-2 mt-2\"><div class=\"text-sm\">30</div><div class=\"text-sm\">30</div><div class=\"text-sm\">30</div></div></div></div>", 1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UserNav = _resolveComponent("UserNav")
  const _component_History = _resolveComponent("History")
  const _component_CurrentReading = _resolveComponent("CurrentReading")
  const _component_GoalHistory = _resolveComponent("GoalHistory")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserNav),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.search && $options.search(...args)), ["prevent"])),
            class: "flex justify-center items-center mt-4"
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.query) = $event)),
              onInput: _cache[1] || (_cache[1] = (...args) => ($options.clearOutput && $options.clearOutput(...args))),
              onKeyup: _cache[2] || (_cache[2] = (...args) => ($options.getSuggestions && $options.getSuggestions(...args))),
              class: "w-full outline-none text-sm bg-white rounded-md border border-gray-400 p-2",
              placeholder: "e.g: Honey & Spice, Bolu Babalola"
            }, null, 544), [
              [_vModelText, $data.query]
            ]),
            _hoisted_6
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchBookResults, (result) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: result.id,
              class: "list-none shadow-reader w-full m-auto text-left z-50"
            }, [
              _createElementVNode("li", _hoisted_8, _toDisplayString(result.volumeInfo.title), 1)
            ]))
          }), 128))
        ]),
        _createVNode(_component_History)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_CurrentReading),
        _createVNode(_component_GoalHistory),
        _hoisted_10
      ])
    ])
  ]))
}